import React from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import styles from '../styles'
import Grid from '@material-ui/core/Grid'
import Body from '../Body'

export default connect(
  state => ({
    wysiwyg:
      state.email.sections?.[state.email?.sectionSelected]?.editor ===
      'wysiwyg',
  }),
  null,
)(
  withStyles(styles)(({ classes, wysiwyg }) => (
    <div>
      <Grid container style={{ padding: '10px' }}>
        <Grid item xs={12}>
          <div style={!wysiwyg ? null : { display: 'none' }}>
            <Body />
          </div>
        </Grid>
      </Grid>
    </div>
  )),
)
